<template>
  <mp-alert-error v-if="errors.length > 0" :errors="errors">
    There was one or more errors loading the station.
  </mp-alert-error>
  <mp-loading-block v-else-if="loading">
    Loading Station
  </mp-loading-block>
  <div v-else>
    <mp-form-text
      ref="name"
      v-model="attributes.name"
      :required="true"
      label="Name"
      description="The alias of the station"
    />
    <mp-form-text
      ref="address"
      v-model="attributes.address"
      :required="true"
      label="Address"
      description="The URL Address of the station stream"
    />
    <mp-form-text
      ref="posterUrl"
      v-model="attributes.posterUrl"
      label="Poster Url"
      description="The URL Address of the poster for this station"
    />
    <mp-form-select
      ref="server"
      v-model="attributes.server"
      label="Server"
      description="The server responsible for this station"
      ajax="/app/lists/servers"
      :http-source-instance="httpResource"
      :required="true"
    />
    <mp-form-select
      ref="clipProfile"
      v-model="attributes.clipProfile"
      label="Clip Profile"
      description="The Default Clipping Profile for this station"
      ajax="/app/lists/clip-profiles"
      :http-source-instance="httpResource"
      :required="true"
    />
    <mp-form-toggle
      ref="enabled"
      v-model="attributes.enabled"
      type="switch"
      label="Enabled"
      description="If this station should be enabled"
    />
    <mp-alert-error v-if="formErrors.length > 0" :errors="formErrors">
      There was one or more errors saving the station.
    </mp-alert-error>
    <div class="buttons">
      <mp-btn type="reset" display-type="light" @click="$emit('close')">
        Cancel
      </mp-btn>
      <mp-btn
        type="submit"
        display-type="primary"
        :loading="saving"
        @click="save"
      >
        Save
      </mp-btn>
    </div>
  </div>
</template>

<script>
import { StationManager } from "../../Manager/StationManager";
import { API } from "@memberpoint/mp-frontend-core";
import FormValidation from "@/VueResources/Mixins/FormValidation";
import AppHttpResource from "@/Kernel/AppHttpResource";
export default {
  name: "EditStationForm",
  mixins: [FormValidation],
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      errors: [],
      loading: false,
      saving: false,
      station: null,
      httpResource: AppHttpResource,
      attributes: {
        name: null,
        address: null,
        enabled: null,
        server: null,
        clipProfile: null,
        posterUrl: null
      },
      formErrors: []
    };
  },
  watch: {
    id: {
      immediate: true,
      handler(nv) {
        if (nv !== null) {
          this.load();
        }
      }
    }
  },
  methods: {
    /**
     * Load up the station
     */
    load() {
      this.loading = true;
      let manager = new StationManager();
      manager
        .getStationById(this.id)
        .then(apiResponse => {
          this.station = apiResponse.getSingleData();
          this.attributes.name = this.station.get("name");
          this.attributes.address = this.station.get("address");
          this.attributes.enabled = this.station.getBool("isEnabled");
          this.attributes.server = this.station.get("serverId");
          this.attributes.posterUrl = this.station.get("posterUrl");
          this.attributes.clipProfile = this.station.get("clipProfileId");
        })
        .catch(err => {
          this.errors = API.SimpleAPIErrorParser.parse(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    save() {
      if (this.refsAreValid("name", "address", "enabled", "server")) {
        this.saving = true;
        let manager = new StationManager();
        manager
          .updateStation(this.id, {
            name: this.attributes.name,
            address: this.attributes.address,
            isEnabled: this.attributes.enabled,
            server: this.attributes.server,
            posterUrl: this.attributes.posterUrl,
            clipProfile: this.attributes.clipProfile
          })
          .then(apiResponse => {
            this.$emit("input");
          })
          .catch(err => {
            this.processFormValidationErrors(
              err,
              {
                name: "name",
                address: "address",
                enabled: "isEnabled",
                server: "server",
                posterUrl: "posterUrl",
                clipProfile: "clipProfile"
              },
              "formErrors"
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>

<style scoped></style>
